import { createSlice } from "@reduxjs/toolkit"

type prontoAiStateType = {
  prontoAiColumns: any[]
  prontoAiTableData: any[]
  prontoAiData: any[]
  prontoAiStoreData: any[]
  selectedMetric: any
  isProntoAiLoading: boolean
}

const initialState: prontoAiStateType = {
  prontoAiColumns: [],
  prontoAiTableData: [],
  prontoAiData: [],
  prontoAiStoreData: [],
  selectedMetric: null,
  isProntoAiLoading: true,
}

const prontoAiSlice = createSlice({
  name: "prontoAi",
  initialState,
  reducers: {
    setProntoAiColumns: (state, action) => {
      state.prontoAiColumns = action.payload
    },
    setProntoAiTableData: (state, action) => {
      state.prontoAiTableData = action.payload
    },
    setProntoAiData: (state, action) => {
      state.prontoAiData = action.payload
    },
    setProntoAiStoreData: (state, action) => {
      state.prontoAiStoreData = action.payload
    },
    setSelectedMetric: (state, action) => {
      state.selectedMetric = action.payload
    },
    setIsProntoAiLoading: (state, action) => {
      state.isProntoAiLoading = action.payload
    },
  },
})

export default prontoAiSlice.reducer

export const {
  setProntoAiColumns,
  setProntoAiTableData,
  setProntoAiData,
  setProntoAiStoreData,
  setSelectedMetric,
  setIsProntoAiLoading,
} = prontoAiSlice.actions
